import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppSessionState } from './app-session.state';

export const selectAppSession = createFeatureSelector<AppSessionState | null>('appSession');

export const selectAccessToken = createSelector(selectAppSession, (session) => (session ? session.accessToken : null));
